module.exports = __webpack_public_path__ + "static/img/icon_decision.e114904f.svg";